export const T = {
  en_GB: {
    maxGoalsReached: "Maximum goals reached",
    maxGoalsDescription: (max: number) => `You can have at most ${max} goals.`,
    cannotDeleteLastGoal: "Cannot delete the last goal",
    cannotDeleteLastGoalDescription: "A flow must have at least one goal.",
    goalDeleted: "Goal deleted",
    failedToCreateGoal: "Failed to add goal. Please try again.",
    failedToDeleteGoal: "Failed to delete goal. Please try again.",
    deleteGoalTitle: "Delete goal",
    deleteGoalDescription: "This goal and its data will be permanently removed.",
    delete: "Delete",
    cancel: "Cancel",
  },
  nb_NO: {
    maxGoalsReached: "Maksimalt antall mål nådd",
    maxGoalsDescription: (max: number) => `Du kan ha maksimalt ${max} mål.`,
    cannotDeleteLastGoal: "Kan ikke slette det siste målet",
    cannotDeleteLastGoalDescription: "En flyt må ha minst ett mål.",
    goalDeleted: "Mål slettet",
    failedToCreateGoal: "Kunne ikke legge til mål. Vennligst prøv igjen.",
    failedToDeleteGoal: "Kunne ikke slette mål. Vennligst prøv igjen.",
    deleteGoalTitle: "Slett mål",
    deleteGoalDescription: "Dette målet og dataene blir permanent fjernet.",
    delete: "Slett",
    cancel: "Avbryt",
  },
} as const;
